import { Component, ElementRef, EventEmitter, HostListener, OnInit } from '@angular/core';
import { VideoRepositoryService } from '../../services/video-repository.service';
import { DwButtonConfig, DwModalConfig, DwModalHandler, DwModalResult } from '@devwareapps/devware-cap';
import { Observable, of } from 'rxjs';
import { VideoEntity } from '../../../../meta-data/app-meta-data.service';

@Component({
  selector: 'app-video-modal',
  templateUrl: './video-modal.component.html',
  styleUrls: ['./video-modal.component.scss']
})
export class VideoModalComponent implements OnInit, DwModalHandler {
  video: VideoEntity;
  videoModalStyle: any = {};

  constructor(private videoRepository: VideoRepositoryService, private elementRef: ElementRef) { }
  modalConfig: DwModalConfig<any>;
  closeModal: EventEmitter<DwModalResult<any>>;

  aspectRating: number = 16 / 9;

  buttonClick(buttonConfig: DwButtonConfig): Observable<DwModalResult> {
    let result = new DwModalResult();

    result.closeModal = true;

    return of(result);
  }

  ngOnInit(): void {

    this.videoRepository.getVideos(this.modalConfig.data)
      .subscribe(videos => {
        if (videos.length > 0) {
          this.video = videos[0];
        }

      });

      this.setupModalStyle();
  }


  @HostListener('window:resize', ['$event'])
  public reset(event: any): void {
    // re-configure the grid style upon browser resize
    this.setupModalStyle();
  }

  setupModalStyle() {
    // if (!this.elementRef?.nativeElement) {
    //   return;
    // }

    const maxWidth = window.innerWidth;
    const maxHeight = window.innerHeight;

    let width = maxWidth - 100;

    if (width < 450) {
      width = maxWidth - 20;
    }

    if (width > 1200) {
      width = 1200;
    }

    let height = width / this.aspectRating;

    if (height > maxHeight) {
      height = maxHeight - 100;
      width = height * this.aspectRating;
    }

    this.videoModalStyle['width'] = width + 'px';
    this.videoModalStyle['height'] = height + 'px';
  }

}
